import { fetchWithAuth, getAuthHeader } from "./http.service";
const API_URL = (process.env.REACT_APP_API_URL || "") + "/api/appointments/";

export interface Appointment {
  id: number;
  serviceName: string;
  date: string;
  time: string;
  price: number;
  durationMinutes: number;
  status: 'PENDING' | 'CONFIRMED' | 'COMPLETED' | 'CANCELLED';
  notes?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

class AppointmentService {
  // Fetch all packages (services) from backend
  getPackages(): Promise<any[]> {
    return fetchWithAuth('/api/packages', { method: "GET" }, false)
      .then((response) => response.json());
  }
  // Fetch all appointments for a specific date (YYYY-MM-DD)
  getAppointmentsForDate(date: string): Promise<any[]> {
    // The backend expects /api/appointments/month/{year}/{month}, so we fetch all for the month and filter client-side
    const [year, month] = date.split('-');
    return fetchWithAuth(`${API_URL}month/${year}/${month}`, { method: "GET", cache: 'no-store' }, false)
      .then((response) => response.json())
      .then((appointments: any[]) => appointments.filter(app => app.date === date));
  }
  getTodaysAppointments(): Promise<any[]> {
    return fetchWithAuth(API_URL + "today", {
      method: "GET",
      headers: getAuthHeader(),
    })
      .then((response) => response.json());
  }

  getMyAppointments(): Promise<Appointment[]> {
    return fetchWithAuth(API_URL + "my", {
      method: "GET",
      headers: getAuthHeader(),
    })
      .then((response) => response.json());
  }

  cancelAppointment(id: number): Promise<Appointment> {
    return fetchWithAuth(API_URL + id + "/cancel", {
      method: "PUT",
      headers: getAuthHeader(),
    })
      .then((response) => response.json());
  }

  createAppointment(
    serviceName: string,
    appointmentDate: string,
    appointmentTime: string,
    price: number,
    durationMinutes: number,
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    notes?: string
  ): Promise<any> {
    if (appointmentTime.length === 5) {
      appointmentTime += ":00";
    }

    return fetchWithAuth(API_URL + "create", {
      method: "POST",
      headers: getAuthHeader(),
      body: JSON.stringify({
        serviceName,
        appointmentDate,
        appointmentTime,
        price,
        durationMinutes,
        firstName,
        lastName,
        email,
        phone,
        notes
      })
    }, false)
    .then((response) => response.json());
  }

  // Block an appointment slot (admin use)
  blockAppointment(date: string, time: string, durationMinutes: number): Promise<any> {
    let appointmentTime = time;
    if (appointmentTime.length === 5) {
      appointmentTime += ":00";
    }

    return fetchWithAuth(API_URL + "block", {
      method: "POST",
      headers: getAuthHeader(),
      body: JSON.stringify({
        date,
        time: appointmentTime,
        durationMinutes
      })
    }).then((response) => response.json());
  }

}


const appointmentService = new AppointmentService();
export default appointmentService;
